/**
 * Pemilih brand — dipakai layar-layar master.
 *
 * ⭐ Ada karena departemen (dan karenanya kategori & produk) **milik brand** sejak migrasi 0034.
 * Tanpa pemilih ini, daftar satu brand akan penuh baris milik brand lain — dan salah pilih tak
 * bergejala sampai laporan per-departemen dibaca.
 *
 * ⚠️ Brand pertama dipilih otomatis: tenant satu-brand (mayoritas) tak perlu mengetuk apa pun,
 * tapi pilihannya tetap TERLIHAT supaya tenant multi-brand tak pernah salah kira.
 */
import { Select } from 'antd';
import { useEffect, useState } from 'react';

import { api } from '../api/client';
import type { Brand } from '../api/client';

export interface BrandPickerProps {
  readonly value: string | null;
  readonly onChange: (id: string) => void;
}

export function BrandPicker({ value, onChange }: BrandPickerProps) {
  const [brand, setBrand] = useState<readonly Brand[]>([]);

  useEffect(() => {
    void api
      .brands()
      .then((r) => {
        setBrand(r);
        const pertama = r[0];
        if (value === null && pertama !== undefined) onChange(pertama.id);
      })
      .catch(() => undefined);
    // ⚠️ Sekali saja: memasukkan `value`/`onChange` membuatnya memilih ulang tiap render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span data-testid="pilih-brand">
      <Select
        style={{ width: 220 }}
        value={value}
        onChange={onChange}
        options={brand.map((b) => ({ value: b.id, label: `${b.code} · ${b.name}` }))}
      />
    </span>
  );
}
